var WITH_URL_GENERATOR = 'WITH_URL_GENERATOR';

var createUrlGeneratorMiddleware = function createUrlGeneratorMiddleware(urlGenerator) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (typeof action.type === 'undefined' || action.type !== WITH_URL_GENERATOR) {
          return next(action);
        }

        return next(function (dispatch) {
          return action.payload(urlGenerator, dispatch, store);
        });
      };
    };
  };
};

export { WITH_URL_GENERATOR };
export default createUrlGeneratorMiddleware;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/withUrlGeneratorMiddleware.js
// module id = null
// module chunks = 